import React from 'react';
import { CTAButton } from './CTAButton';
import { heroBadges, heroTrust, stats, heroTestimonials } from '../data/content';
export function Hero() {
  return <header className="w-full bg-ink-900 px-4 pb-14 pt-9 sm:px-5 sm:pt-14" data-id="element-101" data-mp="ehtm248snfri">
      <div className="mx-auto max-w-4xl text-center" data-id="element-102" data-mp="9lbfcytwl7cj">
        <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-brand-500 sm:text-base" data-id="element-103" data-mp="4m8msdv40tlg">
          🏆 VALUX™ — Infoproductos B2B Argentina
        </p>

        <h1 className="mt-5 text-[2.1rem] font-extrabold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl" style={{
        fontSize: "28px"
      }} data-id="element-104" data-mp="127ec173d7daa">
          Tu operación mayorista. Automatizada.
          <span className="mt-2 block text-brand-500" data-id="element-105" data-mp="sd4aaysj92mw">Desde hoy.</span>
        </h1>

        <div className="mx-auto mt-8 w-full max-w-[420px]" data-id="element-106" data-mp="nbyir4alzley">
          <img src="https://cdn.magicpatterns.com/uploads/kRw3Xcfd3C9TWfxVsqUE8S/Mockup_Sistema_Despacho_Total_Landing_Page_1_WEBP_200KB.webp" alt="Sistema Despacho Total: 2 tomos y 10 bonos para mayoristas argentinos" className="h-auto w-full object-contain" style={{
          width: "355px",
          height: "174px"
        }} data-id="element-107" data-mp="3d1sa6w93nhsl" />
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-base font-bold leading-snug text-brand-500 sm:text-xl" style={{
        fontSize: "15px"
      }} data-id="element-108" data-mp="3o73na61tdk5f">
          El sistema N°1 para mayoristas, fabricantes y distribuidores en
          Argentina — Del caos de chats al despacho automático.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-gray-300 sm:text-base" data-id="element-109" data-mp="30gzuktq5z4t7">
          Tomo 1 + Tomo 2 + 10 Bonos — Todo el sistema listo para instalar.
        </p>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-110" data-mp="2qkmthasahoof">
          {heroBadges.map(badge => <li key={badge} className="rounded-lg border border-white/10 bg-ink-700 px-3 py-2 text-[11px] font-semibold text-gray-200 sm:text-sm" data-id="element-111" data-mp="2vjg50xo0n5ly">
              {badge}
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-112" data-mp="s1rt2qgj2avc">
          <CTAButton href="#precios" className="py-5 text-sm sm:text-lg" data-id="element-113" data-mp="s3mfk97g6b1j">
            📦 QUIERO MI SISTEMA DESPACHO TOTAL™ →
          </CTAButton>
        </div>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-medium text-gray-400 sm:gap-x-6 sm:text-sm" data-id="element-114" data-mp="ibgm0v1jrlk8">
          {heroTrust.map(item => <li key={item} data-id="element-115" data-mp="1b1fg54ulm8vr">{item}</li>)}
        </ul>

        <p className="mt-12 text-xs font-extrabold uppercase tracking-[0.2em] text-gray-400" data-id="element-116" data-mp="1ayt7t2zvvpch">
          📊 Resultados en números
        </p>

        <dl className="mx-auto mt-5 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-117" data-mp="1126mye7k4yag">
          {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-white/10 bg-ink-800 px-3 py-5 sm:px-4" data-id="element-118" data-mp="x0cu2s3lsyku">
              <dt className="sr-only" data-id="element-119" data-mp="3hrlmgnykwhbm">{stat.label}</dt>
              <dd data-id="element-120" data-mp="3hpsgzbzpc357">
                <span className="block text-2xl font-extrabold text-brand-500 sm:text-3xl" data-id="element-121" data-mp="3htq03xma4up3">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[11px] text-gray-400 sm:text-sm" data-id="element-122" data-mp="21a4ubxltom71">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <p className="mt-12 text-xs font-extrabold uppercase tracking-[0.2em] text-gray-400" data-id="element-123" data-mp="2b0zdgt3rv5o9">
          Lo que dicen los que ya lo tienen
        </p>

        <div className="mx-auto mt-6 grid max-w-5xl gap-4 text-left md:grid-cols-3" data-id="element-124" data-mp="2g1wuv3gyjvop">
          {heroTestimonials.map(item => <figure key={item.initials} className="rounded-2xl border border-white/10 bg-ink-800 p-5" data-id="element-125" data-mp="2ozz3a430tqm0">
              <div className="flex items-center gap-3" data-id="element-126" data-mp="2tz1zr04xqoid">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-500 text-sm font-bold text-ink-900" data-id="element-127" data-mp="umzfvosefs46">
                  {item.initials}
                </span>
                <span className="text-xs text-yellow-400" data-id="element-128" data-mp="4b47lugz66jz">⭐⭐⭐⭐⭐</span>
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-gray-200" data-id="element-129" data-mp="3vhp4hutpo8ox">
                {item.quote}
              </blockquote>
              <figcaption className="mt-3 text-xs font-semibold text-brand-500" data-id="element-130" data-mp="e8innsyzktbr">
                {item.author}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </header>;
}